module.exports = __webpack_public_path__ + "img/link-preview-placeholder-image.3b022727.png";